var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"exclamation"},[_c('ExclamationIcon',{staticClass:"icon"})],1),_c('h1',{staticClass:"page-title"},[_vm._v("There’s a problem")]),_c('p',[_vm._v("\n    This page could not be found.\n  ")]),_c('router-link',{staticClass:"btn btn--big",attrs:{"to":"/"}},[_vm._v("Back Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }